export const SLIDER_API = 'https://appscasa.com/backend/public/api/slider';
export const BLOGS_API = 'https://appscasa.com/backend/public/api/blog';
export const SERVICES_API = 'https://appscasa.com/backend/public/api/service';
export const FEATURE_API = 'https://appscasa.com/backend/public/api/feature';
export const CONTACT_US_API = 'https://appscasa.com/backend/public/api/contact';
export const JOIN_US_API = 'https://appscasa.com/backend/public/api/joinus';
export const BOOK_NOW_API = 'https://appscasa.com/backend/public/api/booknow';

  